import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "features-swiper",
  class: "bg-verylightgray",
  "data-aos": "fade-up"
}
const _hoisted_2 = { class: "container py-5" }
const _hoisted_3 = { class: "text-center mb-2" }
const _hoisted_4 = { class: "text-verydarkblue font-weight-bold mb-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "d-inline-block border-bottom border-9 w-30 w-md-10 border-color1 mb-3" }, null, -1)

import { onMounted } from 'vue';
import { useGlobalStore, useConfigStore } from '@/stores';


export default /*#__PURE__*/_defineComponent({
  __name: 'OurValues',
  setup(__props) {

const globalStore = useGlobalStore();
const configStore = useConfigStore();

onMounted(() => {
  globalStore.fetchValues(undefined);
});

return (_ctx: any,_cache: any) => {
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.$t('OUR_VALUES')), 1),
        _hoisted_5
      ]),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(globalStore).values, (value, index) => {
            return (_openBlock(), _createBlock(_component_v_col, {
              key: index,
              cols: "12",
              md: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  title: _unref(configStore).stringLang(value.valueAr, value.valueEn),
                  text: 
              _unref(configStore).stringLang(value.descriptionAr, value.descriptionEn)
            ,
                  class: "text-center",
                  variant: "flat"
                }, null, 8, ["title", "text"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})